import { memo } from 'react';
import Modal from 'react-bootstrap/Modal';

const BzModalBody = ({ className, ...props }) => {
    return (
        <Modal.Body  {...props} className={className}>
            {props.children}
        </Modal.Body>
    );
};

export default memo(BzModalBody);